import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProgramDetails, ProgramList } from "../action/ProgramDetailAction";
import { stat } from "fs";

const initialState: ProgramList = {
  programs: [],
};

const programSlice = createSlice({
  name: "programs",
  initialState,
  reducers: {
    setPrograms: (state, action: PayloadAction<ProgramDetails[]>) => {
      state.programs = action.payload;
    },
    clearPrograms: (state) => {
      state.programs = [];
    },
  },
});

export const { setPrograms, clearPrograms } = programSlice.actions;

export default programSlice.reducer;
